import { Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useCallback, useState } from 'react';

import { CurrentInvestment } from './current-investment';
import { InvestmentGoalTracker } from './investment-goal-tracker';

export const PerformanceGraphs = ({ clientID, isClient }: { clientID?: string; isClient?: boolean }) => {
  const [currentTab, setCurrentTab] = useState('currentInvestment');

  const handleChangeTab = useCallback((event: SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  }, []);

  const TABS = [
    {
      value: 'currentInvestment',
      label: 'Current Investment',
    },
    {
      value: 'investmentGoalTracker',
      label: 'Investment Goal Tracker',
    },
  ];

  const getTabElement = () => {
    if (currentTab === 'currentInvestment') {
      return <CurrentInvestment clientID={clientID} isClient={isClient} />;
    }
    if (currentTab === 'investmentGoalTracker') {
      return <InvestmentGoalTracker clientID={clientID} isClient={isClient} />;
    }
  };
  return (
    <>
      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        sx={{
          p: 2,
          '& .MuiTabs-flexContainer': {
            justifyContent: 'end',
            display: 'flex',
          },
        }}
      >
        {TABS.map((tab) => (
          <Tab key={tab.value} iconPosition="end" value={tab.value} label={tab.label} />
        ))}
      </Tabs>
      {getTabElement()}
    </>
  );
};
